<template lang="pug">
#heatmap_menu
  label
    span 対象期間
    help-tooltip(html-key='heatmapDate')
  form.form-inline.mb-3
    .form-group.mr-3
      select.form-control(v-model="selectedDate" @change="dateSelectChange")
        option(v-for='date in $store.state[this.state_name].date_for_select',:value="date.k",:key="date.k")
          | {{date.v}}
    .form-group
      vuejs-datepicker(:disabled-dates="disabledDates", :format="DatePickerFormat",:language="language", :value="$store.state[this.state_name].date_from", @selected="selectDateFrom", input-class="form-control", :placeholder="placeholder_date_from")
    .form-group &nbsp;~&nbsp;
    .form-group
      vuejs-datepicker(:disabled-dates="disabledDates", :format="DatePickerFormat",:language="language", :value="$store.state[this.state_name].date_to", @selected="selectDateTo", input-class="form-control", :placeholder="placeholder_date_to")
  p.text-xs.text-muted.font-weight-light(v-if='has_date_restrict')
    span ※現在のプランでは {{heatmap_available_date}}日 前まで閲覧可能
    span.ml-2
      a(href="/users/plans/upgrade" target="_blank") プランアップグレードはこちら

  .row.mb-3
    .col-2
      label デバイス
      .row
        .col-6
          button.btn.btn-xs.btn-block(:class="($store.state[this.state_name].device == 'sp') ? 'btn-primary' : 'btn-default' ", @click="setDevice('sp')")
            i.fas.fa-mobile-alt.mr-2
            | SP
        .col-6
          button.btn.btn-xs.btn-block(:class="($store.state[this.state_name].device == 'pc') ? 'btn-primary' : 'btn-default' ", @click="setDevice('pc')")
            i.fas.fa-desktop.mr-2
            | PC
    .col-9.offset-1
      label 最終イベント
      .row
        .col-2
          button.btn.btn-xs.btn-block(:class="(event == '') ? 'btn-primary' : 'btn-default' ", @click="setEvent('')")
            | 指定なし
        .col-2
          button.btn.btn-xs.btn-block(:class="(event == 'click') ? 'btn-primary' : 'btn-default' ", @click="setEvent('click')")
            i.fas.fa-mouse.mr-2
            | クリック
          help-tooltip(html-key='heatmapClickPv')
        .col-2
          button.btn.btn-xs.btn-block(:class="(event == 'popstate') ? 'btn-primary' : 'btn-default' ", @click="setEvent('popstate')")
            i.fas.fa-undo-alt.mr-2
            | ブラウザバック
        .col-3
          button.btn.btn-xs.btn-block(:class="(event == 'blur') ? 'btn-primary' : 'btn-default' ", @click="setEvent('blur')")
            i.fas.fa-external-link-alt.mr-2
            | 別ウィンドウ移動
        .col-2
          button.btn.btn-xs.btn-block(:class="(event == 'other') ? 'btn-primary' : 'btn-default' ", @click="setEvent('other')")
            | その他

  label OS
  .row(v-if='device =="pc" ')
    .col-3
      button.btn.btn-sm.btn-block(:class="(os == '') ? 'btn-primary' : 'btn-default' ", @click="setOs('')")
        | 指定なし
    .col-3
      button.btn.btn-sm.btn-block(:class="(os == 'windows') ? 'btn-primary' : 'btn-default' ", @click="setOs('windows')")
        i.fab.fa-windows.mr-2
        | Windows
    .col-3
      button.btn.btn-sm.btn-block(:class="(os == 'mac') ? 'btn-primary' : 'btn-default' ", @click="setOs('mac')")
        i.fab.fa-apple.mr-2
        | Mac
  .row(v-if='device =="sp" ')
    .col-3
      button.btn.btn-sm.btn-block(:class="(os == '') ? 'btn-primary' : 'btn-default' ", @click="setOs('')")
        | 指定なし
    .col-3
      button.btn.btn-sm.btn-block(:class="(os == 'android') ? 'btn-primary' : 'btn-default' ", @click="setOs('android')")
        i.fab.fa-android.mr-2
        | Android
    .col-3
      button.btn.btn-sm.btn-block(:class="(os == 'ios') ? 'btn-primary' : 'btn-default' ", @click="setOs('ios')")
        i.fab.fa-apple.mr-2
        | iOS
</template>

<script>
import Vue from 'vue';

import vuejsDatepicker from 'vuejs-datepicker';

//mixins
import DateformatMixin from '../mixins/date_format.js';

export default {
  props: {
    date_from: String,
    date_to: String,
    date_yesterday_start: String,
    date_yesterday_end: String,
    date_month_start: String,
    date_last_month_start: String,
    date_last_month_end: String,
    heatmap_disabled_date_to: String,
    heatmap_available_date: String,
    has_date_restrict: Boolean,
    state_name: {
      type: String,
      default: "heatmap"
    },
  },
  data() {
    var d = new Date(this.heatmap_disabled_date_to);
    d.setDate(d.getDate() - 1);
    return {
      DatePickerFormat: 'yyyy-MM-dd',
      selectedDate: this.$store.state[this.state_name].date_for_select[2].k,
      language:{
        language: 'Japanese',
        months: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
        monthsAbbr: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
        days: ['日', '月', '火', '水', '木', '金', '土'],
        rtl: false,
        ymd: 'yyyy-MM-dd',
        yearSuffix: '年'
      },
      disabledDates: {
        to: d,
      }
    }

  },
  methods: {
    async getScroll(){
      if(this.show_scroll_heatmap){
        await this.$store.dispatch(`${this.state_name}/getScroll`)
      }
    },
    async getClick(){
      if(this.show_click_heatmap){
        await this.$store.dispatch(`${this.state_name}/getClick`)
      }
    },
    async getAttention(){
      if(this.show_attention_heatmap){
        await this.$store.dispatch(`${this.state_name}/getAttention`)
      }
    },
    async selectDateFrom(date){
      const date_from = this.formatDateToBegining(date)
      this.$store.commit(`${this.state_name}/setDateFrom`, date_from)
      await this.getScroll();
      await this.getClick();
      await this.getAttention();
    },
    async selectDateTo(date){
      const date_to = this.formatDateToEnd(date)
      this.$store.commit(`${this.state_name}/setDateTo`, date_to)
      await this.getScroll();
      await this.getClick();
      await this.getAttention();
    },
    async dateSelectChange(e){
      const date = e.target.value
      if(date == 'today'){
        this.$store.commit(`${this.state_name}/setDateFrom`, this.date_from)
        this.$store.commit(`${this.state_name}/setDateTo`, this.date_to)
      } else if(date == 'yesterday'){
        this.$store.commit(`${this.state_name}/setDateFrom`, this.date_yesterday_start)
        this.$store.commit(`${this.state_name}/setDateTo`, this.date_yesterday_end)
      } else if(date == 'this_month'){
        this.$store.commit(`${this.state_name}/setDateFrom`, this.date_month_start)
        this.$store.commit(`${this.state_name}/setDateTo`, this.date_to)
      } else if(date == 'last_month'){
        this.$store.commit(`${this.state_name}/setDateFrom`, this.date_last_month_start)
        this.$store.commit(`${this.state_name}/setDateTo`, this.date_last_month_end)
      }
      await this.getScroll();
      await this.getClick();
      await this.getAttention();
    },
    async setDevice(v){
      this.$store.commit(`${this.state_name}/setDevice`, v)
      this.setOs('')
      await this.getScroll();
      await this.getClick();
      await this.getAttention();
    },
    async setEvent(v){
      this.$store.commit(`${this.state_name}/setEvent`, v)
      await this.getScroll();
      await this.getClick();
      await this.getAttention();
    },
    async setOs(v){
      this.$store.commit(`${this.state_name}/setOs`, v)
      await this.getScroll();
      await this.getClick();
      await this.getAttention();
    }
  },
  async mounted(){
    await Vue.nextTick()
    this.$store.commit(`${this.state_name}/setDateFrom`, this.date_month_start)
    this.$store.commit(`${this.state_name}/setDateTo`, this.date_to)
  },
  watch: {
  },
  mixins: [DateformatMixin],
  components: {
    vuejsDatepicker
  },
  computed: {
    gradient() {
      return this.$store.getters[`${this.state_name}/gradient`];
    },
    event(){
      return this.$store.state[this.state_name].event_type;
    },
    device(){
      return this.$store.state[this.state_name].device;
    },
    os(){
      return this.$store.state[this.state_name].os;
    },
    placeholder_date_from(){
      console.log("this.$store.state[this.state_name].date_from", this.$store.state[this.state_name].date_from)
      return this.$store.state[this.state_name].date_from.replace("00:00:00", "");
    },
    placeholder_date_to(){
      return this.$store.state[this.state_name].date_to.replace("23:59:59", "");
    },
    show_scroll_heatmap(){
      return this.$store.state[this.state_name].show_scroll_heatmap;
    },
    show_click_heatmap(){
      return this.$store.state[this.state_name].show_click_heatmap;
    },
    show_attention_heatmap(){
      return this.$store.state[this.state_name].show_attention_heatmap;
    }
  }
}
</script>
<style lang="scss" scoped>
.chart_line{
  position:absolute;
  width:100%;
  left:0;
  .chart_unit{
    .chart_thin{
      display:inline-block;
      left:0;
      margin-bottom: 1px;
      border-bottom: dotted 1px #444;
    }
    .chart_bold{
      display:inline-block;
      height:3px;
      left:0;
      background-color: #444;
    }
  }
}

.balloon{
	position: relative;
  display: inline-block;
  padding: 2px 5px;
  width: auto;
  color: #F6F6F6;
  text-align: center;
  background: #19283C;
  z-index: 0;
  border-radius: 0px;
  font-size: 14px;
}

.balloon::after{
  content: "";
  position: absolute;
  bottom: -10px;
  left: 10px;
  margin-left: -10px;
  display: block;
  width: 0px;
  height: 0px;
  border-style: solid;
  border-width: 10px 0px 0 10px;
  border-color: #19283C transparent transparent transparent;
}
.gradient{
  position:absolute;
  top:0;
  left:0;
  width:100%;
  height:100%;
  opacity:0.6;
  //background: #000;
}
</style>
